export default {
    GAME_START: 'game-start',
    GAME_PAUSE: 'game-pause',
    GAME_RESUME: 'game-resume',
    LOOT_ITEM_SPAWN: 'loot-item-spawn',
    LOOT_ITEM_PICKUP: 'loot-item-pickup',
    GAME_FINISH: 'game-finish',
    GAME_OVER: 'game-over'
};
